import React from 'react';

interface ChartTooltipProps {
  tooltip: Highcharts.Tooltip | null;
}

export const ChartTooltip = ({ tooltip }: ChartTooltipProps) => {
  const point = tooltip?.chart.hoverPoint;

  return (
    <>
      <span style={{ color: `${point?.color}` }}>●</span>{' '}
      {point?.options?.name || point?.category}:{' '}
      <b>{`${point?.y || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</b>
    </>
  );
};
